<template>
  <div class="login">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="4">
          <v-card class="pb-4">
            <v-row class="pa-5">
              <v-col>
                <v-img
                  src="@/assets/logo.png"
                  alt="logo"
                  contain
                  height="150"
                ></v-img>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <h3 class="headline grey--text text-center my-5">
                  Welcome to Wenn
                </h3>
                <h3 class="grey--text text-center my-5">
                  Log Into your Account
                </h3>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="mx-5">
                <v-form>
                  <v-text-field
                    autofocus
                    label="Username"
                    name="username"
                    v-model="username"
                    prepend-icon="mdi-account"
                    type="text"
                    @keyup.enter.native="login"
                  />

                  <v-text-field
                    id="password"
                    label="Password"
                    v-model="password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    @keyup.enter.native="login"
                  />
                </v-form>
                <v-row v-if="$store.state.errors.state">
                  <v-col>
                    <span class="text--red">{{
                      $store.state.errors.message
                    }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-right">
                    <v-btn @click="login" :loading="$store.state.auth.loading">
                      Login
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Login',

  data: () => ({
    username: '',
    password: ''
  }),

  methods: {
    login() {
      this.$store.dispatch('errors/reset');
      this.$store.dispatch('auth/login', {
        username: this.username,
        password: this.password
      });
    }
  }
};
</script>
